'use client';

import { createContext, PropsWithChildren, useContext } from 'react';

type NetworkCardContextData = {
  network: AdaptedNetwork;
};

const NetworkCardContext = createContext({} as NetworkCardContextData);

export type NetworkCardContextProps = PropsWithChildren<{
  network: AdaptedNetwork;
}>;

export function NetworkCardContextProvider({
  network,
  children,
}: NetworkCardContextProps) {
  return (
    <NetworkCardContext.Provider value={{ network }}>
      {children}
    </NetworkCardContext.Provider>
  );
}

export function useNetworkCard() {
  const context = useContext(NetworkCardContext);

  if (!context) {
    throw new Error('useNetworkCard must be used within a NetworkCardProvider');
  }

  return context;
}
